import { useMediaQuery, useTheme } from "@mui/material";
import {
  createFileRoute,
  Outlet,
  useLocation,
  useNavigate,
} from "@tanstack/react-router";
import { useCreateTeam } from "@trainwell/features/freemium-plans";
import { useEffect, useState } from "react";
import BasicLayout from "src/components/BasicLayout";
import { useButtonStore } from "src/components/ButtonState";
import { useTeamState } from "src/components/teams/TeamState";
import { useCurrentUserId } from "src/features/useCurrentUserId";

export const Route = createFileRoute("/create/_layout")({
  component: LayoutComponent,
});

function LayoutComponent() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const teamName = useTeamState((state) => state.teamName);
  const enableButton = useButtonStore((state) => state.isButtonEnabled);
  const setButtonEnabled = useButtonStore((state) => state.setButtonEnabled);
  const isButtonVisible = useButtonStore((state) => state.isVisible);
  const setVisible = useButtonStore((state) => state.setVisible);
  const userId = useCurrentUserId();
  const setShareUrl = useTeamState((state) => state.setShareUrl);
  const setShareText = useTeamState((state) => state.setShareText);

  const { mutate: createTeam } = useCreateTeam({
    mutationConfig: {
      onSuccess: (data) => {
        console.log("createTeam success", data);
        setShareUrl(data.invite_data?.share_url);
        setShareText(data.invite_data?.message_copy);
        navigate({ to: "/create/invite" });
      },
    },
  });

  // Decide which page is next.
  const nextPage = () => {
    const currentPath = location.pathname;
    console.log("nextPage", currentPath);
    if (currentPath === "/create") {
      console.log("nextPage: /create/name");
      navigate({ to: "/create/name" });
    } else if (currentPath === "/create/name") {
      console.log("teamName", teamName);
      // The successful resolution of this will navigate to the next page.
      // TODO(akrulec): Figure out how to acquire the user ID of the creator.
      if (teamName) {
        createTeam({
          name: teamName,
          created_by: userId,
        });
      }
    } else if (currentPath === "/create/invite") {
      navigate({ to: "/create/qrCode" });
    } else if (currentPath === "/create/qrCode") {
      // Don't navigate anywhere. Hide button.
    }
  };

  useEffect(() => {
    const currentPath = location.pathname;

    // Decide which image to show on the left side of the screen.
    if (currentPath === "/create") {
      setVisible(true);
      setButtonEnabled(true);
      setImageUrl("/assets/onboarding-images/page-1.jpg");
    } else if (currentPath === "/create/name") {
      setVisible(true);
      setButtonEnabled(false);
      setImageUrl("/assets/onboarding-images/page-1.jpg");
    } else if (currentPath === "/create/invite") {
      setVisible(true);
      setButtonEnabled(true);
      setImageUrl("/assets/onboarding-images/page-1.jpg");
    } else if (currentPath === "/create/qrCode") {
      setVisible(false);
      setImageUrl(null);
    }
  }, [location.pathname]);

  return (
    <BasicLayout
      imageUrl={imageUrl}
      isDesktop={isDesktop}
      buttonText="Continue"
      enableButton={enableButton}
      isButtonVisible={isButtonVisible}
      onNextPage={nextPage}
      theme={theme}
    >
      <Outlet />
    </BasicLayout>
  );
}
